export default __webpack_public_path__ + "media/images/react_icons/phone_dark-a2efd1e0194f6d0810b868c787206e79.svg";